/* CG1 disclosure follows the actual selected variant. Every reported flavour remains visible without JavaScript. */
(function () {
  'use strict';
  var results = { peach: ['Peach', '1.26'], watermelon: ['Watermelon', '1.35'], pineapple: ['Pineapple', '1.41'], grape: ['Grape', '1.45'] };
  function mount(node) {
    if (node.dataset.psCg1Mounted) return;
    node.dataset.psCg1Mounted = 'true';
    var variants;
    try { variants = JSON.parse(node.querySelector('[data-ps-cg1-variants]').textContent); } catch (_) { return; }
    var byId = {};
    variants.forEach(function (v) { byId[String(v.id)] = v; });
    var output = node.querySelector('[data-ps-cg1-selected]');
    function show(variant) {
      if (!variant || !byId[String(variant.id)]) return;
      var title = String(byId[String(variant.id)].title || '').toLowerCase();
      var key = Object.keys(results).find(function (flavour) { return title.indexOf(flavour) !== -1; });
      var text = key ? results[key][0] + ': ' + results[key][1] + ' g creatine per gummy' : 'Check your flavour’s reported result below.';
      if (output.textContent !== text) {
        var strong = document.createElement('strong');
        strong.textContent = text;
        output.replaceChildren(strong);
      }
      node.querySelectorAll('[data-cg1-flavour]').forEach(function (row) { row.dataset.selected = String(row.dataset.cg1Flavour === key); });
    }
    function fromForm(event) {
      var target = event && event.target;
      var form = target && target.closest && target.closest('form');
      var selected;
      if (form) {
        var field = form.querySelector('[name="id"]');
        selected = field && byId[String(field.value)];
      }
      if (!selected) {
        var fields = document.querySelectorAll('form[action*="/cart/add"] [name="id"]');
        for (var i = 0; i < fields.length; i++) {
          if (byId[String(fields[i].value)]) { selected = byId[String(fields[i].value)]; break; }
        }
      }
      show(selected);
    }
    function fromEvent(event) {
      var data = event.detail || event.data || event;
      var variant = data.variant || (data.data && data.data.variant);
      if (variant) show(variant); else fromForm(event);
    }
    document.addEventListener('change', function (event) { fromForm(event); window.setTimeout(function () { fromForm(event); }, 0); });
    ['variant:change', 'variant-change', 'product:variant-change', 'ps:variant-change'].forEach(function (name) { document.addEventListener(name, fromEvent); });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.variantChange, fromEvent);
    document.querySelectorAll('form[action*="/cart/add"] [name="id"]').forEach(function (input) {
      if (!byId[String(input.value)]) return;
      new MutationObserver(function () { show(byId[String(input.value)]); }).observe(input, { attributes: true, attributeFilter: ['value'] });
    });
    var initial = new URLSearchParams(window.location.search).get('variant');
    if (initial && byId[initial]) show(byId[initial]); else fromForm();
  }
  function start() { document.querySelectorAll('[data-ps-cg1]').forEach(mount); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
}());
